import { getEnvBaseUrl } from '@/utils'
import { http } from '@/utils/http'
import { loginAuth } from '@/utils/loginAuth'
import {
  ApplyForClubData,
  BackAllClubListData,
  BackUserInfo,
  BackUserJoindedClubListData,
  ClubMemberInfoUpdateData,
  FilterGetAllClubList,
  IBackTokenInfo,
  NicknameAuditConfigVo,
  RefreshShortTokenInfo,
  SendLoginData,
  SetApprovalUserNickName,
  SetPlantFromUserInfo,
  UsersInfo,
  WxPlatformLoginData,
} from './loginType'

const authBaseUrl = getEnvBaseUrl().authBaseUrl

const appId = import.meta.env.VITE_WX_APPID

/**
 * 获取用户信息 获取登录用户俱乐部成员信息
 */
export function requestGetUserInfo() {
  return http.get<BackUserInfo>('/clubs/members/me')
}

/**
 * 获取微信登录凭证
 * @returns Promise 包含微信登录凭证(code)
 */
export function getWxCode() {
  return new Promise<UniApp.LoginRes>((resolve, reject) => {
    uni.login({
      provider: 'weixin',
      success: res => resolve(res),
      fail: err => reject(new Error(err)),
    })
  })
}

/**
 * 微信登录
 * @param params 微信登录参数，包含code
 * @returns Promise 包含登录结果
 */
export function requestPostLoginToken(data: WxPlatformLoginData) {
  const postData: SendLoginData = {
    ...data,
    appId,
    grant_type: 'wx_code',
  }

  return loginAuth.post<IBackTokenInfo>(
    `${authBaseUrl}/oauth2/token`,
    postData,
    {},
    {
      'Authorization': 'Basic ZWFzeXBsYXktd3g6ZWFzeXBsYXk=',
      'content-type': 'application/x-www-form-urlencoded',
    },
  )
}

/**
 * 刷新短token
 */
export function requestPostRefreshShortToken(data: RefreshShortTokenInfo) {
  return loginAuth.post<IBackTokenInfo>(
    `${authBaseUrl}/oauth2/token`,
    {
      refresh_token: data.refresh_token,
      clubId: data.clubId,
      role: data.role,
      grant_type: 'wx_refresh_token',
    },
    {},
    {
      'refresh_token': data.refresh_token,
      'Authorization': 'Basic ZWFzeXBsYXktd3g6ZWFzeXBsYXk=',
      'content-type': 'application/x-www-form-urlencoded',
    },
  )
}

/**
 * 获取俱乐部列表，模糊搜索俱乐部
 */
export function requestGetAllClubList(data: FilterGetAllClubList) {
  return http.get<BackAllClubListData>('/clubs', data)
}

/**
 * 申请加入俱乐部
 */
export function requestPostApplyForClub(data: ApplyForClubData) {
  return http.post('/clubs/join', data)
}

/**
 * 审核加入俱乐部的申请
 */
export function auditClubJoin(data: any) {
  return http.post('/clubs/join/audit', data)
}

// 获取用户信息
export function requestGetUserInfoById(userId: string) {
  return http.get<UsersInfo>(
    `/users/${userId}`,
  )
}

/**
 * 设置平台用户头像昵称
 */
export function requestPutSetUserName(data: SetPlantFromUserInfo) {
  return http.put(
    '/users/me',
    data,
    {},
    {
      'content-type': 'application/x-www-form-urlencoded',
    },
  )
}

/**
 * 设置俱乐部成员昵称，是否审核由后端规则和当前身份决定
 */
export function requestPutSetMemberUserInfo(data: SetApprovalUserNickName) {
  return http.put(
    '/clubs/members/profile/me/approval',
    data,
  )
}

/**
 * 查询修改昵称是否需要审核
 */
export function requestGetNicknameAuditRequired() {
  return http.get<NicknameAuditConfigVo>(
    '/clubs/members/profile/me/nickname-audit-required',
  )
}

/**
 * 设置俱乐部用户基本信息，不包含昵称
 */
export function requestPutSetMemberUserMessage(data: ClubMemberInfoUpdateData) {
  return http.put(
    '/clubs/members/profile/me',
    data,
  )
}

/**
 * 获取用户加入的所有的俱乐部和身份
 */
export function requestGetUserClubList() {
  return http.get<BackUserJoindedClubListData>('/clubs/joined')
}

/**
 * 扫码授权登录
 */
export function requestPostScanCodeAuth(key: string) {
  return http.post(
    `/login/grant/${key}`,
    {},
    {},
    {},
    { hideErrorToast: true },
  )
}
